/* globals angular */
(function () {
  'use strict';

  angular.module('wsLrs.controllers').
  /**
   * This allows outside controllers to interact with the CustomDateFilter model and
   * provides an encapsulated controller to handle interaction logic for the
   * CustomDateFilter model without cluttering the quickFilterEditor directive.
   */

  controller('CustomDateViewCtrl', ['$scope', 'CustomDateFilter', 'QuickFilterEditorModel', '$filter', function ($scope, CustomDateFilter, QuickFilterEditorModel, $filter) {
    var vm = this;
    vm.customDateFilter = CustomDateFilter;
    // Tooltip when hovering over custom date picker pills
    vm.datePopoverText = function (date) {
      var hasType = date && date.dateFilter && date.dateFilter.dateType;
      if (!hasType) {
        return;
      }
      var from = $filter('date')(date.dateFilter.customDateFrom, 'MMM d, y h:mm a');
      var to = $filter('date')(date.dateFilter.customDateTo, 'MMM d, y h:mm a');
      var tips = {
        'custom': "<p>".concat(from, " - ").concat(to, "</p>"),
        'trailing': "<p>From ".concat(date.dateFilter.trailingAmount, " ").concat(date.dateFilter.trailingAmount > 1 ? date.dateFilter.trailingType : date.dateFilter.trailingType.replace(/s$/, ''), " ago until now</p>"),
        'none': "<p>All Date Ranges</p>"
      };
      return tips[date.dateFilter.dateType];
    };
    vm.cancelCustomDateFilterCreator = function (index) {
      QuickFilterEditorModel.revertCustomDateFilter(index).then(function () {
        CustomDateFilter.reset();
        CustomDateFilter.showCreationView = false;
      });
    };
    vm.createCustomDateFilter = function () {
      vm.customDateFilter = CustomDateFilter.reset();
      CustomDateFilter.showCreationView = true;
    };
    vm.saveCustomDateFilter = function () {
      QuickFilterEditorModel.saveCustomDateFilter().then(function () {
        CustomDateFilter.reset();
        vm.cancelCustomDateFilterCreator();
      });
    };
    vm.editCustomDateFilter = function (customDateFilter, index) {
      CustomDateFilter.edit(customDateFilter, index);
      CustomDateFilter.showCreationView = true;
    };
    vm.deleteCustomDateFilter = function () {
      QuickFilterEditorModel.deleteCustomDateFilter(CustomDateFilter.index).then(function () {
        CustomDateFilter.reset();
        CustomDateFilter.showCreationView = false;
      });
    };
    $scope.$on('$destroy', function () {
      CustomDateFilter.reset();
    });
  }]);
})(this);
